import { render } from "./TheHeaderCreateButton.vue?vue&type=template&id=740375ae"
import script from "./TheHeaderCreateButton.vue?vue&type=script&lang=js"
export * from "./TheHeaderCreateButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__